/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MergeInventoryTags$Params {
  inventoryId: string;
  keepTagId: string;
  mergeTagId: string;
}

export function mergeInventoryTags(http: HttpClient, rootUrl: string, params: MergeInventoryTags$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, mergeInventoryTags.PATH, 'patch');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
    rb.query('keepTagId', params.keepTagId, {});
    rb.query('mergeTagId', params.mergeTagId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

mergeInventoryTags.PATH = '/admin/inventories/tags/merge';
